import script from "./goRinSyo0071.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0071.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0071.vue?vue&type=style&index=0&id=8eab673c&lang=scss"

const __exports__ = script;

export default __exports__